import { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { useBrands } from '../contexts/BrandContext'
import { AdminHeader } from './admin/AdminHeader'
import { AdminSideNav } from './admin/AdminSideNav'
import { loadVcards } from '../services/vcardStore'
import { loadAccounts } from '../services/accountStore'
import type { NavCounts } from './shell/navConfig'

/**
 * Admin-Konsolen-Shell (BMC-Designsystem `console.css`): `.shell`-Header +
 * rollenabhängige `.side`-Nav + `.canvas` mit zentriertem `.wrap` (`<Outlet/>`).
 * Nav-Counts werden resilient geladen (Fehler → leere Counts, kein Crash).
 */
export function AdminLayout() {
  const { session } = useAuth()
  const { brands } = useBrands()
  const [counts, setCounts] = useState<NavCounts>({})

  useEffect(() => {
    // user hat keine Admin-Konsole → keine Counts (defensiv, per Guard eigentlich
    // ausgeschlossen).
    if (!session || session.role === 'user') {
      setCounts({})
      return
    }
    let cancelled = false
    Promise.all([loadVcards(session), loadAccounts(session)])
      .then(([vcards, accounts]) => {
        if (cancelled) return
        setCounts({ brands: brands.length, accounts: accounts.length, vcards: vcards.length })
      })
      .catch(() => {
        if (!cancelled) setCounts({})
      })
    return () => {
      cancelled = true
    }
  }, [session, brands])

  if (!session) return null // durch RequireAuth abgesichert

  return (
    <div className="app">
      <AdminHeader session={session} />
      <div className="body">
        <AdminSideNav role={session.role} counts={counts} />
        <main className="canvas">
          <div className="wrap">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}
